import { forwardRef, type Ref, type SVGProps } from "react";
const IconRateOkFilledSVG = (
  { children, ...rest }: SVGProps<SVGSVGElement>,
  ref: Ref<SVGSVGElement>
) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    aria-hidden="true"
    viewBox="0 0 32 32"
    ref={ref}
    {...rest}
  >
    {children}
    <path d="M16 2A14 14 0 1 1 2 16 14 14 0 0 1 16 2m4.52 17.5h-9.64a1 1 0 0 0 .12 2h9.63a1 1 0 0 0-.11-2M12 11a2 2 0 1 0 2 2 2 2 0 0 0-2-2m8 0a2 2 0 1 0 2 2 2 2 0 0 0-2-2" />
  </svg>
);
const ForwardRef = forwardRef(IconRateOkFilledSVG);
ForwardRef.displayName = "IconRateOkFilled";
export { ForwardRef as IconRateOkFilled };
